// terminPrivatAnzeige.ts — Anzeige-Seite privater Termine (PO 27.07.2026).
//
// Die eigentliche Maskierung passiert im BACKEND (`apps/api/src/calendar/
// termin-privat.ts`): ein fremder privater Termin kommt hier bereits ohne
// Betreff, Ort, Teilnehmer und Text an. Das Frontend entscheidet nichts über
// Sichtbarkeit — es beschriftet nur.
//
// Absichtlich eine eigene kleine Datei statt eines Imports aus apps/api: die
// beiden Anwendungen teilen keinen Code, und ein dupliziertes Prädikat ist
// billiger als eine Abhängigkeit quer über die Paketgrenze.

/** Graph-Stufen, die als vertraulich gelten — spiegelt das Backend. */
const VERTRAULICH = new Set(["private", "personal", "confidential"]);

export function istVertraulich(sensitivity: string | null | undefined): boolean {
    return VERTRAULICH.has(String(sensitivity ?? "").toLowerCase());
}
